import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/data/code/equirize/prod/layouts/default.vue").then(m => m.default || m))
}